export default __webpack_public_path__ + "a497bb919cf0d63b1236a63e7a6986bb.svg";